module.exports = __webpack_public_path__ + "img/403-Access-Forbidden-HTML-Template.95bf9b29.gif";